export const getMonthString = (month: number) => {
    if (month === 0) {
        return "Jan";
    }
    if (month === 1) {
        return "Feb";
    }
    if (month === 2) {
        return "Mar";
    }
    if (month === 3) {
        return "Apr";
    }
    if (month === 4) {
        return "May";
    }
    if (month === 5) {
        return "Jun";
    }
    if (month === 6) {
        return "Jul";
    }
    if (month === 7) {
        return "Aug";
    }
    if (month === 8) {
        return "Sep";
    }
    if (month === 9) {
        return "Oct";
    }
    if (month === 10) {
        return "Nov";
    }
    if (month === 11) {
        return "Dec";
    }
}

export const GetTodaysDateString = () => {
    const todaysDate = new Date();
    const month = todaysDate.getMonth();
    const monthStr = getMonthString(month);
    const day = todaysDate.getDate();
    const year = todaysDate.getFullYear();
    const dateStr = monthStr + "-" + String(day) + "-" + String(year);
    return dateStr;
}